import request from '@/utils/request'

/**
 * 获取库存交易类型列表
 */
export function getInventoryTransactionTypes(params) {
  return request({
    url: '/api/inventory-transaction-types',
    method: 'get',
    params
  })
}

/**
 * 创建库存交易类型
 */
export function createInventoryTransactionType(data) {
  return request({
    url: '/api/inventory-transaction-types',
    method: 'post',
    data
  })
}

/**
 * 更新库存交易类型
 */
export function updateInventoryTransactionType(typeId, data) {
  return request({
    url: `/api/inventory-transaction-types/${typeId}`,
    method: 'put',
    data
  })
}

/**
 * 删除库存交易类型
 */
export function deleteInventoryTransactionType(typeId) {
  return request({
    url: `/api/inventory-transaction-types/${typeId}`,
    method: 'delete'
  })
}

/**
 * 切换库存交易类型状态
 */
export function toggleInventoryTransactionTypeStatus(typeId, data) {
  return request({
    url: `/api/inventory-transaction-types/${typeId}/status`,
    method: 'patch',
    data
  })
}
